import cn from 'classnames';

import OPE from 'js/on-page-editing';
import { defineTheme, type ThemeKeys } from 'js/utils/theme-helpers';

import { IByline } from 'source/NFR.types';

const themes = defineTheme({
  border: 'byline--theme-border'
});
type BylineTheme = ThemeKeys<typeof themes>;
interface BylineProps extends IByline {
  theme?: BylineTheme;
}

const Byline: React.FC<BylineProps> = ({ items = [], theme }) => (
  <div className={cn('byline', themes(theme))}>
    {items?.map(item =>
      item.text || item.onPageEditing ? (
        <div className="byline--item" key={item.text} {...OPE(item.onPageEditing)}>
          {item.text}
        </div>
      ) : null
    )}
  </div>
);

Byline.displayName = 'Byline';

export default Byline;
